import WsService from "./WsService";
import CustomerLimit from "../domain/CustomerLimit";

const ENDPOINT_BASE = "/admin/customer-limit";

export default class CustomerLimitService {

    static retrieveCustomerLimit(registrationId) {

        let endpoint = ENDPOINT_BASE + "?registration-id=" + registrationId;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                return new CustomerLimit(response);
            },
            response => {
                return response;
            }
        )

    }

}